const _ = "2-digit", A = "long", o = "numeric", t = "short", s = "shortOffset", T = {
  month: A,
  day: o,
  year: o
}, E = {
  hour: _,
  minute: _
}, O = {
  ...T,
  ...E,
  month: t,
  hour12: !1
}, n = { ...O, year: void 0 }, R = { ...T, month: "short" }, M = T, c = n, S = { ...T, weekday: A }, e = { ...T, month: t }, I = O, D = n, F = {
  ...T,
  ...E,
  weekday: A,
  timeZoneName: s
};
export {
  R as DATE_FORMAT_CAPITAL_OVERVIEW,
  M as DATE_FORMAT_PAYOUTS,
  c as DATE_FORMAT_PAYOUTS_MOBILE,
  S as DATE_FORMAT_PAYOUT_DETAILS,
  e as DATE_FORMAT_REPORTS,
  I as DATE_FORMAT_TRANSACTIONS,
  D as DATE_FORMAT_TRANSACTIONS_MOBILE,
  F as DATE_FORMAT_TRANSACTION_DETAILS
};
